import React from "react";
import "../Stylesheets/agentform.scss";
import logo from "../assets/images/testprop.jpeg";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { propertyget } from "../apidata";
import axios from "axios";
import $ from "jquery";
import { contactform } from "../apidata";
import arrow from "../assets/images/small/back-arrow.png";
import PhoneInput from "react-phone-input-2";
import { countryes } from "./projects/countries";
import "react-phone-input-2/lib/bootstrap.css";
export default function AgentForm(props) {
  const [phoneee, setPhoneee] = useState("");

  const formData = new FormData();

  const [getdata, setGetData] = useState([]);

  const [creatfirstname, setCreatefirstname] = useState("");
  const [fnerror, setfnerror] = useState(false);
  const [creatlastname, setCreatelastname] = useState("");
  const [lnerror, setlnerror] = useState(false);

  const [creatphoneno, setCreatephoneno] = useState("");
  const [pnerror, setpnerror] = useState(false);

  const [createPostcode, setPostcode] = useState("");
  const [pcerror, setpcerror] = useState(false);

  const [description, setdescription] = useState("");

  const [email, setemail] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [EmailRequired, setEmailRequired] = useState(false);
  const [country, setcountry] = useState("");
  const [countryerror, setcountryerror] = useState(false);
  const [checked1, setchecked1] = useState(false);
  const [checked2, setchecked2] = useState(false);

  const [propertysell, setpropertysell] = useState("");
  const [propertysellerror, setpropertysellerror] = useState(false);
  const [propertytel, setpropertytel] = useState("");
  const [Url, setUrl] = useState("")
  const [uinqid, setuniqid] = useState("");
  const [propertytelerror, setpropertytelerror] = useState(false);
  const [mailpopup, setmailpopup] = useState(false);
  const propertyid = useSelector((state) => state.counter.propertyid);
  useEffect(() => {
    $("html, body").animate({ scrollTop: "0px" }, 100);
    props.loaderchange(true);
    const val=window.location.href.split("=")
    setuniqid(val[1])
    const val1=window.location.href.split("/")
    setUrl(val1[3])
    axios({
      method: "get",
      url: propertyget + val[1] + "/",
      headers: { "content-type": "application/json" },
    })
      .then((res) => {
        setGetData(res.data.data);
        setTimeout(() => {
          props.loaderchange(false);
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const validation = (e) => {
    if (e.target.name == "first_name") {
      setCreatefirstname(e.target.value);
      setfnerror(false);
    } else if (e.target.name == "last_name") {
      setCreatelastname(e.target.value);
      setlnerror(false);
    } else if (e.target.name == "telephone") {
      setCreatephoneno(e.target.value);
      setpnerror(false);
    } else if (e.target.name == "email") {
      setemail(e.target.value);
      setValidEmail(false);
      setEmailRequired(false);
      if (e.target.value == "") {
        setEmailRequired(true);
      }
      // } else if (e.target.name == "postcode") {
      //   if (e.target.value.length < 9) {
      //     setPostcode(e.target.value);
      //     setpcerror(false);
      //   }
    } else if (e.target.name == "message") {
      setdescription(e.target.value);
    }
  };

  const submitclick = (e) => {
    console.log(getdata.property_address);
    if (
      creatfirstname != "" &&
      creatlastname != "" &&
      creatphoneno != "" &&
      // createPostcode != "" &&
      email != ""
      // country != ""
      // propertysell!="" &&
      // propertytel!=""
    ) {
      formData.append("more_details", checked1);
      formData.append("view_property", checked2);
      formData.append("first_name", creatfirstname);
      formData.append("last_name", creatlastname);
      formData.append("telephone", creatphoneno);
      formData.append("email", email);
      formData.append("country", country);
      // formData.append("postcode", createPostcode);
      formData.append("message", description);
      formData.append("postcode", getdata.property_address);
      props.loaderchange(true);

      axios({
        method: "post",
        url: contactform,
        data: formData,
        headers: {
          "content-type": "application/json",
        },
      })
        .then((res) => {
          // console.log(res.data.data, "lkijiji");
          props.loaderchange(false);
          setmailpopup(true);
          setTimeout(() => {
            setmailpopup(false);
            window.location.reload();
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      if (creatfirstname == "") {
        setfnerror(true);
      }
      if (creatlastname == "") {
        setlnerror(true);
      }

      if (creatphoneno == "") {
        setpnerror(true);
      }
      // if (createPostcode == "") {
      //   setpcerror(true);
      // }
      if (email == "") {
        setValidEmail(true);
      }
      if (country == "") {
        setcountryerror(true);
      }
      if (propertysell == "") {
        setpropertysellerror(true);
      }
      if (propertytel == "") {
        setpropertytelerror(true);
      }
    }
  };

  const handleChangecountry = (event) => {
    setcountry(event.target.value);
    setcountryerror(false);
  };

  const handleChangepropertysell = (event) => {
    setpropertysell(event.target.value);
    setpropertysellerror(false);
  };
  const handleChangepropertylet = (event) => {
    setpropertytel(event.target.value);
    setpropertytelerror(false);
  };

  const checkbox1 = (e) => {
    setchecked1(e.target.checked);
  };
  const checkbox2 = (e) => {
    setchecked2(e.target.checked);
  };
  $(".text_area").keyup(function () {
    var characterCount = $(this).val().length,
      current = $("#current"),
      maximum = $("#maximum"),
      theCount = $("#the-count");

    current.text(characterCount);

    /*This isn't entirely necessary, just playin around*/
    if (characterCount < 10) {
      current.css("color", "#666");
    }
    if (characterCount > 70 && characterCount < 50) {
      current.css("color", "#6d5555");
    }
    if (characterCount > 90 && characterCount < 100) {
      current.css("color", "#793535");
    }
    if (characterCount > 100 && characterCount < 210) {
      current.css("color", "#841c1c");
    }
    if (characterCount > 120 && characterCount < 350) {
      current.css("color", "#8f0001");
    }

    if (characterCount >= 550) {
      maximum.css("color", "#8f0001");
      current.css("color", "#8f0001");
      theCount.css("font-weight", "bold");
    } else {
      maximum.css("color", "#666");
      theCount.css("font-weight", "normal");
    }
  });

  return (
    <div className="container-xxl">
      <div className="agent_form">
        <div className="row " style={{ padding: "20px", width: "100%" }}>
          <div className="col-md-8 mb-5">
            <div className="form_main">
              <h1 className="form_head">{getdata.property_name}</h1>
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ display: "flex", flexDirection: "row", gap: "16px" }}
                >
                  <div
                    className="eabout"
                    style={{
                      fontWeight: 700,
                      fontSize: "20px",
                      marginBottom: "10px",
                    }}
                  >
                    <p className="back_to_result">
                      <a href={`/${Url}/details?id=${uinqid}`}>
                        <img src={arrow} /> Back to search results
                      </a>
                    </p>
                    Take the Next Steps Towards Your Perfect Investment
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: 300,
                        marginTop: "10px",
                      }}
                    >
                      Fill in your details below to explore more about potential
                      UK properties with lucrative returns
                    </p>
                  </div>
                  <div className="propertyadd">{getdata.property_name}</div>
                </div>
                <div className="col-md-12 check">
                  <div className="eabout">I would like:</div>
                  <div className="checkbox1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      checked={checked1}
                      onChange={(e) => checkbox1(e)}
                      id="invalidCheck"
                      required
                    ></input>
                    <label class="form-check-label" for="invalidCheck">
                      More details
                    </label>
                  </div>
                  <div className="checkbox1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      checked={checked2}
                      onChange={(e) => checkbox2(e)}
                      id="invalidCheck"
                      required
                    ></input>
                    <label class="form-check-label" for="invalidCheck">
                      To view a property
                    </label>
                  </div>
                </div>
                <div className="col-md-6" style={{ margin: "16px 0" }}>
                  <label for="validationCustom01" class="form-label">
                    First name
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="validationCustom01"
                    name="first_name"
                    autoComplete="off"
                    placeholder="Eg.John"
                    required
                    value={creatfirstname}
                    onChange={(e) => validation(e)}
                  ></input>
                  {fnerror == true ? (
                    <p
                      style={{
                        marginTop: "13px",
                        color: "red",
                        fontSize: "13px",
                      }}
                    >
                      Please share your first name
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6" style={{ margin: "16px 0" }}>
                  <label for="validationCustom02" class="form-label">
                    Last name
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="validationCustom01"
                    name="last_name"
                    autoComplete="off"
                    placeholder="Eg.Smith"
                    required
                    value={creatlastname}
                    onChange={(e) => validation(e)}
                  ></input>
                  {lnerror == true ? (
                    <p
                      style={{
                        marginTop: "13px",
                        color: "red",
                        fontSize: "13px",
                      }}
                    >
                      Please share your last name
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label for="validationCustom03" class="form-label">
                    Phone
                  </label>
                  <PhoneInput
                    name="telephone"
                    country={"gb"}
                    enableSearch={true}
                    placeholder="Eg. 07700 900 000"
                    countryCodeEditable={false}
                    onChange={(value) => {
                      setCreatephoneno(value);
                    }}
                    style={{
                      paddingleft: "30px",
                    }}
                  />
                  {/* <input
                    type="number"
                    class="form-control"
                    id="validationCustom03"
                    autoComplete="off"
                    name="telephone"
                    value={creatphoneno}
                    required
                    placeholder="Eg. 07700 900 000"
                    onChange={(e) => validation(e)}
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-", "."].includes(evt.key) &&
                      evt.preventDefault()
                    }
                  ></input> */}
                  {pnerror == true ? (
                    <p
                      style={{
                        marginTop: "13px",
                        color: "red",
                        fontSize: "13px",
                      }}
                    >
                      Please share a valid phone number, including any dialling
                      code
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label for="validationCustomUsername" class="form-label">
                    Email
                  </label>
                  <div class="input-group has-validation">
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustomUsername"
                      aria-describedby="inputGroupPrepend"
                      autoComplete="off"
                      name="email"
                      value={email}
                      required
                      placeholder="Eg. john.smith@email.com"
                      onChange={(e) => validation(e)}
                    ></input>
                    <p
                      style={{
                        marginTop: "13px",
                        color: "red",
                        fontSize: "13px",
                      }}
                    >
                      {EmailRequired
                        ? "Please share a email address"
                        : validEmail
                        ? "Please share a valid email address"
                        : ""}{" "}
                    </p>
                  </div>
                </div>
                <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label htmlFor="validationCustom04" className="form-label">
                    Country
                  </label>
                  <select
                    className="form-select"
                    id="validationCustom04"
                    name="country"
                    required
                    value={country}
                    onChange={(e) => {
                      handleChangecountry(e);
                    }}
                  >
                    <option selected disabled value="">
                      Please Select
                    </option>
                    {countryes.map((countryItem) => (
                      <option key={countryItem.code} value={countryItem.code}>
                        {countryItem.name}
                      </option>
                    ))}
                  </select>

                  {countryerror === true ? (
                    <p
                      style={{
                        marginTop: "13px",
                        color: "red",
                        fontSize: "13px",
                      }}
                    >
                      Please share a Country name
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {/* <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label for="validationCustom04" class="form-label">
                    Country
                  </label>
                  <select
                    class="form-select"
                    id="validationCustom04"
                    name="country"
                    required
                    value={country}
                    onChange={(e) => {
                      handleChangecountry(e);
                    }}
                  >
                    <option selected disabled value="">
                      Please Select
                    </option>
                    <option value={"0"}>UK</option>
                    <option value={"1"}>USA</option>
                    <option value={"2"}>INDIA</option>
                  </select> */}
                {/* {country !=""&&country.map((ele)=>{
                      <option value={ele.name}>{ele.name}</option>
                    })} */}

                {/* {countryerror == true ? (
                    <>
                      <p
                        style={{
                          marginTop: "13px",
                          color: "red",
                          fontSize: "13px",
                        }}
                      >
                        Please share a Country name
                      </p>
                    </>
                  ) : (
                    ""
                  )}
                </div> */}
                {/* <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label for="validationCustom01" class="form-label">
                    Postcode
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="validationCustom01"
                    name="postcode"
                    autoComplete="off"
                    placeholder="Eg. MK6 1AJ"
                    value={createPostcode}
                    required
                    onChange={(e) => validation(e)}
                  ></input>
                  {pcerror == true ? (
                    <p
                      style={{
                        marginTop: "13px",
                        color: "red",
                        fontSize: "13px",
                      }}
                    >
                      Please share your full postcode, e.g. MK6 1AJ
                    </p>
                  ) : (
                    ""
                  )}
                </div> */}
                <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label for="validationCustom01" class="form-label">
                    Your message (Optional)
                  </label>
                  <textarea
                    type="textarea"
                    class="form-control text_area"
                    id="validationCustom01"
                    name="message"
                    style={{ resize: "none", height: "auto" }}
                    rows="3"
                    maxlength="700"
                    required
                    placeholder="Start Typing"
                    value={description}
                    onChange={(e) => validation(e)}
                  ></textarea>
                  <div id="the-count" style={{ padding: "8px" }}>
                    <span id="current">0</span>
                    <span id="maximum">/ 700 characters</span>
                  </div>
                </div>

                {/* <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label for="validationCustom04" class="form-label">
                    I have a property to sell
                  </label>
                  <select
                    class="form-select"
                    id="validationCustom04"
                    name="propertysell"
                    required
                    value={propertysell}
                    onChange={(e)=>{handleChangepropertysell(e)}}

                  >
                    <option selected disabled value="">
                      Please Select
                    </option>
                    <option value={"No"}>No</option>
                    <option value={"Yes, it is not yet on the market"}>
                      Yes, it is not yet on the market
                    </option>
                    <option value={"Yes, it is on the market already"}>
                      Yes, it is on the market already
                    </option>
                    <option value={"Yes, it is under offer"}>
                      Yes, it is under offer
                    </option>
                    <option value={"Yes, it is already exchanged"}>
                      Yes, it is already exchanged
                    </option>
                  </select>
                  {propertysellerror==true?(
                    <>
                    <p style={{marginTop:"13px",color:'red',fontSize:"13px"}}>Please tell us if you have a property to sell</p>
                    </>
                  ):""}

                </div>
                <div className="col-md-12" style={{ margin: "16px 0" }}>
                  <label for="validationCustom04" class="form-label">
                    I have a property to let
                  </label>
                  <select
                    class="form-select"
                    id="validationCustom04"
                    name="property let"
                    required
                    value={propertytel}
                    onChange={(e)=>{handleChangepropertylet(e)}}

                  >
                    <option selected disabled value="">
                      Please Select
                    </option>
                    <option value={"No"}>No</option>
                    <option value={"Not yet, I intend to buy to let"}>
                      Not yet, I intend to buy to let
                    </option>
                    <option value={"Yes, it is available to let now"}>
                      Yes, it is available to let now
                    </option>
                    <option value={"Yes, it will be available to let soon"}>
                      Yes, it will be available to let soon
                    </option>
                    <option value={"Yes, it is currently occupied"}>
                      Yes, it is currently occupied
                    </option>
                  </select>
                  {propertytelerror==true?(
                    <>
                    <p style={{marginTop:"13px",color:'red',fontSize:"13px"}}>Please tell us if you have a property that you let</p>
                    </>
                  ):""}
                </div> 
                <div
                  className="col-md-12"
                  style={{
                    margin: "16px 0",
                    display: "flex",
                    flexDirection: "row",
                    gap: "37px",
                    marginTop: "16px",
                  }}
                >
                  <div className="eabout">I would like:</div>
                  <div className="checkbox3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      // checked={checked}
                      // onChange={(e) => checkbox(e)}
                      id="invalidCheck"
                      required
                    ></input>
                    <label class="form-check-label" for="invalidCheck">
                      My property valued
                    </label>
                  </div>
                </div>*/}
                <div className="col-md-12" style={{ margin: "20px 0" }}>
                  <button className="submit" onClick={(e) => submitclick(e)}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-5">
            <div className="card right_card">
              <div className="card_content">
                <div
                  className="card_imglogo"
                  style={{ borderRadius: "8px 8px 0px 0px" }}
                >
                  <img
                    // src={logo}
                    src={
                      getdata.media_files && getdata.media_files.length > 0
                        ? getdata?.media_files[0]
                        : ""
                    }
                    className="logo"
                    style={{ width: "100%", borderRadius: "8px 8px 0px 0px" }}
                  ></img>
                </div>
                <div className="card_price">
                  <div style={{ fontWeight: "700" }}>
                    £
                    {getdata.price != ""
                      ? String(getdata.price).replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ","
                        )
                      : ""}
                  </div>
                </div>
                <div className="card_main_content">
                  <div className="prop_data">
                    <div className="data1">{getdata.bedrooms} bedroom flat</div>
                    <i class="fas fa-bed" style={{ marginRight: "10px" }}>
                      <span style={{ display: "inline", padding: "10px" }}>
                        {getdata.bedrooms}
                      </span>
                    </i>
                  </div>
                  <div className="card_add">{getdata.property_name}</div>
                </div>
                <div className="card_hl"></div>
              </div>
              <div className="marketed_by">
                {/* <div className="img_marketing">
                  <p>Marketed By</p>
                  <img src={logo} className="marketing_logo"></img>
                </div>
                <div className="company_name">Dexter</div> */}
                <div className="company_address">
                  {getdata.property_address}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {mailpopup && (
        <div className="mail_confirmation">
          <div className="row bootstrap snippets bootdeys">
            <div className="col-md-5 col-md-offset-3">
              <div
                className="m-t-30 card-box"
                style={{
                  marginBottom: 20,
                  backgroundClip: "padding-box",
                  MozBorderRadius: 5,
                  borderRadius: 5,
                  WebkitBorderRadius: 5,
                  padding: 20,
                  backgroundColor: "#ffffff",
                  boxShadow: "0 8px 42px 0 rgba(0, 0, 0, 0.08)",
                  width: "400px",
                }}
              >
                <div className="text-center">
                  <h4 className="text-uppercase font-bold m-b-0">Success !!</h4>
                </div>
                <div className="panel-body text-center">
                  <img
                    className="icon icons8-Star-Filled"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAGz0lEQVR4Xu2dXXIjNRDHJXvhld0TkLxRBQlxbfKM9wSYE2BOwPgEmBNkcgLCCcieAPMcbzmbQBVvZE+w9ius3bTGM1mPP8YaTbestsdvrtJopP5J0+r/tDRa1b+gLKCDao1jY85G0fO7Vjx2vDyoy/YCyMmbqGus+vAyvg7Kug6N2Q8gw+j3BMh5/MrBBkFdIh7IF6Po6NOp/sdY9d8mHP/dih+DsnDJxogHcjrsxdjnH9N+X92fX0YlbRBU8T0AEuHs0Edzq8Lj/Xl8HJSFSzZGNJCTYdTRSv+22GdQ8B36kpuSdgimuHAgvRvswLd5IOr1w/llJxgLl2yIWCAm9phN9ft1/W004YXUuEQskNM3UaRAX64dgBp69y9j4+zF/eQCGS4682W7y3XuIoF8OYrOmlM9Khr+0ya0/mrFd9KmiEggJ8PeNTb8+yJjg1K/onPv1kCYLTB35srEHs+LbwXjRlMdS3Pu4maIERI16F9suIOGH6QJjvKAoJCIwWDbCoiCgTTBURSQRSHRBogpI01wFAVkSUi0ZSJKcBQGJMLIfJszlx2TiAGyTki0nSKSBEdBQFaFRHsgcgRHEUBcnPkyLCnOXQSQQiHRdpoIERxlACkUEm2JyBAcgwfy1W3UbmidZJVU/c0AXv15EQ+q1sN5ffBAbIREWwNJEByDBmIvJFojCV5wDBpIGSHRGknggmPQQE5vo5HS+szW2FblAO7uL+KWVdkdFAoWCEXsscmeIcckwQJxFBJtx3SwgmPAQFyERFseMMYMxxe2pX2WCxJIFSHR1nihCo7BADGZJA3QnyUGnUHf9q2gLYAVUR7fJqqG7ie30zAJJUOlEhDjeD8B/fliZ/VMnSkNuQQEANXOlVHq6GOCtKtJua+DRwwkH3Pt1iof5YMeQ0PlUo2aGt5WSaxIgCQB2OwppT9pAxrRLDdzhuUetdwm3lX9+HjMg1RqrHUeZKOhrgzIpxmSakYma3z+2Kh/viwwQY2tk2lsuUdW8hyfapOE9rWv1hzyffCR+HbWhO6i/1rxIebxNZ1DyaX5H7LhOPqOMF43Ecayv9no1FG26KNs8RNHYw6+ToCfUb7pr7ND4SorFfdMWn/tV2hG0QSzKaOibMqty94009w4+9zylqZ9B1XLO8zI72yLd7YCyZbF0w/6Bpdq3xyUCYk6iyHEH81n0LGJT6yAZO2ifHtH1Nfgqyn7lrIUENN7jpdGwVvVsYEu2felgZi2pX5lUDv7jaQm6C/a2/xF6VVW0cBI45VBHUTmrWSCPYwv2jb+ghTIk7Of6hihFG4vc5zx4i4z/gJhRK4wTIedHlnLliLJLBRn/qUGE2VGkgAxTTtgcTInDlYdV2RAMmd/SOLkOnEwKCALfmXvxclN4mBwQLIG7bU4WSAOBgtkIYjcJ3Fygm//upzHP5H6kHWjY4/ESStxMOgZkjUuCSIFi5NlxEERQLJGChUnvWY5sj+ylkeMJHHSRRwUNUMWVmD0We1VLbF8/Y6y5L3PkKKj+ahtWrW+XRwV6B1I/cgqHib+gVgcPlZ1ZFNdX/ZtH8V9vQM5JdniTNF1mzr8b6X2CoRzV5SNeV3K+N5t5RWIyPcmRO85bAeDVyAYGK6cRG3b0F2VM6quz5OyvQJB/+Fw3tWuUGT39bv9zRsQm7N2d236Tff3eQawNyCi34949CPegJzc9gZSU1GN2vtwcdn2MYO9AcF95+gf5f7wyz1ebOXlJj62OXOj9nW0kxcgzKcycLPI6vfyXsQPEI5DZD5imOA27H7yF5J95zybizzJ8exAOOX25VScZN/8PLWVZX+kDzmeHQiT3F6Y/ZH6rGvq2eLjOA5+IMRyu21CM8duYh9yPDsQQrn9Ha50umUPsUxzjs1sIdgjyS/HswIhlNuv8Pndd03zT/2YcfjZF0GdV2bccjwrkKpyu0lmBoCo7KzYZG2K2cKdicIKpJLczpg/W0VX45bjWYG4yO0cKf7rZoz7uS68cjwbEAe5PQnwfH8QMp0t5gvT1gElpxzPBqTMY8Goqf89g+6uvoWeBJQf8MAd24MRGOV4NiCWcvtOZsUmp58uQrbKL5xyPBuQbXI71w4k5/VseqGt/MIlx7MA2SK3s296qQrFXL9NfuGS41mAbJLbbWUPCoNS1LFFfmGR43mArMrtTrIHhVEp6lgbUDLJ8eRA1sjtlWQPCoNS1LFOfuGQ48mBZHI7texBYVSKOhZnC4ccTw/EyO2AquiGMwUpjBJCHSbOAq2PqD8RTg7ETG1XVTYEQ5dpA0dfyYGU6VBddtUCNZDARkUNpAYSmAUCa049Q2oggVkgsOb8DyLTXpIAnjF9AAAAAElFTkSuQmCC"
                    width={100}
                    height={100}
                  />
                  <p
                    className="text-muted font-13 m-t-20"
                    style={{ color: "#9a9da0" }}
                  >
                    Thank you for providing your details, we will get in touch
                    shortly!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
